import SettingsConfirm from "./SettingsConfirm";
import SettingBoard from "./SettingBoard";

export default SettingBoard;
export { SettingsConfirm };
